import { cached } from '@porotutu/react'
import { listQueryOf } from '@porotutu/react/paging'
import { createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { permittedRoute, signedInRoute } from '@/router/root'
import { CRM_SEGMENT_SORTABLE, SEGMENT_FILTERS, SEGMENT_KINDS } from '../vocabulary'
import { segmentQuery, segmentsQuery } from './queries'

const segmentSearch = (raw: Record<string, unknown>) =>
  listQueryOf(raw, CRM_SEGMENT_SORTABLE, [], SEGMENT_FILTERS, { segment_kind: SEGMENT_KINDS })

export const segmentsRoute = createRoute({
  getParentRoute: () => signedInRoute,
  beforeLoad: permittedRoute('segments'),
  path: '/segments',
  validateSearch: segmentSearch,
  loaderDeps: ({ search }) => search,
  loader: ({ context, deps }) => context.queryClient.query(cached(segmentsQuery(deps))),
  component: lazyRouteComponent(() => import('./pages'), 'SegmentsPage'),
})

export const segmentRoute = createRoute({
  getParentRoute: () => signedInRoute,
  beforeLoad: permittedRoute('segments'),
  path: '/segments/$id',
  validateSearch: segmentSearch,
  loader: ({ context, params }) => context.queryClient.query(cached(segmentQuery(params.id))),
  component: lazyRouteComponent(() => import('./pages'), 'SegmentPage'),
})

export const segmentRoutes = [segmentsRoute, segmentRoute]
